"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryPartCommandContract = void 0;
const uuid_1 = require("uuid");
class StoryPartCommandContract {
    constructor(partId, partType, partBody) {
        this.partId = partId || (0, uuid_1.v4)();
        this.partType = partType;
        this.partBodyJson = JSON.stringify(partBody);
    }
}
exports.StoryPartCommandContract = StoryPartCommandContract;
//# sourceMappingURL=storyPartCommandContract.js.map